<template>
  <div class="controls container" oncontextmenu="return false;">
    <div class="controls__panel">
      <button 
        class="button button--secondary button--small controls__cta"
        @click="goToSignup"
      >
        Add your brick!
      </button>
      <div class="controls__buttons">

        <div class="controls__path">
          <button @click="toggleZoom" :class="['controls__button', isZoomed ? 'controls__button--path-out' : 'controls__button--path-in']"></button>
          <p class="controls__label">Zoom</p>
        </div>
        
        <div class="controls__walk">
          <button
            @mousedown="goForward"
            @mouseup="stopMovement"
            @touchstart="goForward"
            @touchend="stopMovement"
            @touchcancel="stopMovement"
            :class="['controls__button', 'controls__button--arrow-up', isMovingUp && 'controls__button--active']"
          ></button>
          <button
            @mousedown="goBackward"
            @mouseup="stopMovement"
            @touchstart="goBackward"
            @touchend="stopMovement"
            @touchcancel="stopMovement"
            :class="['controls__button', 'controls__button--arrow-down', isMovingDown && 'controls__button--active']"
          ></button>
          <p class="controls__label">Walk Up/Down</p>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Controls',

    props: ['isZoomed', 'isMovingUp', 'isMovingDown'],

    methods: {
      goToSignup(){
        this.$emit('goToSignup', 'signup');
      },

      goForward(){
        this.$emit('goForward', true);
      },
      goBackward(){
        this.$emit('goBackward', true);
      },
      stopMovement(){
        this.$emit('stopMovement', true);
      },
      toggleZoom(){
        this.$emit('toggleZoom', this.zoomed);
      }
    }

  }
</script>